import { ServiceFunction } from "utils/index";
import BaseService from "../base";
import ProcedureFileStepService from "./procedureFileStepService";
import SignOffStepService from "./signOffStepService";
import {
  IDownloadFilePayload,
  IFlowDataPayload,
  IFlowDataResponse,
  IGetProcedureInfoPayload,
  IGetProcedureInfoResponse,
  IGetShowEditPermissionPayload,
  IGetShowEditPermissionResponse,
  IGetTaskInfoPayload,
  IGetTaskInfoResponse,
  IProcedureFileSectionResponse,
  IProcedureFileStepItem,
  ISetSectionLockPayload,
  RegisterFileSharePayload,
  RegisterFileShareResponse,
} from "./types";

class ProcedureDetailService extends BaseService {
  submitSupprotingFileForApproval = (para: any, success: any, error: any) => {
    // @ts-ignore
    this.sendRequest("submitSupprotingFileForApproval", para, success, error);
  };

  updateSupprotingFileForApproval = (para: any, success: any, error: any) => {
    // @ts-ignore
    this.sendRequest("updateSupprotingFileForApproval", para, success, error);
  };

  saveSupprotingFileAsDraft = (para: any, success: any, error: any) => {
    // @ts-ignore
    this.sendRequest("saveSupprotingFileAsDraft", para, success, error);
  };

  getSupportingFileList = (para: any, success: any, error: any) => {
    // @ts-ignore
    this.sendRequest("getSupportingFileList", para, success, error);
  };

  submitForApproval = (para: any, success: any, error: any) => {
    // @ts-ignore
    this.sendRequest("submitForApproval", para, success, error);
  };

  updateForApproval = (para: any, success: any, error: any) => {
    // @ts-ignore
    this.sendRequest("updateForApproval", para, success, error);
  };

  saveAsDraft = (para: any, success: any, error: any) => {
    // @ts-ignore
    this.sendRequest("saveAsDraft", para, success, error);
  };

  addFile = (para: any, success: any, error: any, returnPara: any, number = 0) => {
    // @ts-ignore
    this.sendExternalRequest("addFile", para, success, error, returnPara, true).catch((ex) => {
      if (number < 10) {
        number++;
        this.addFile(para, success, error, returnPara, number);
      }

      throw ex;
    });
  };

  deleteFile = (para: any, success: any, error: any, returnPara: any) => {
    // @ts-ignore
    this.sendExternalRequest("deleteFile", para, success, error, returnPara);
  };

  downloadFile: ServiceFunction<IDownloadFilePayload, Response> = (
    para,
    success,
    error,
    returnPara
  ) => {
    const downloadPara = {
      ProductKey: para.ProductKey,
      FileID: para.storageFileID[0],
    };
    // @ts-ignore
    return this.sendExternalRequest("downloadFile", downloadPara, success, error, returnPara);
  };

  getProcedureFileList = (para: any, success: any, error: any) => {
    // @ts-ignore
    this.sendRequest("getProcedureFileList", para, success, error);
  };

  getTaskInfo = (para: any, success: any, error: any) => {
    // @ts-ignore
    this.sendRequest("getTaskInformation", para, success, error);
  };

  submitProcedureInfo = (para: any, success: any, error: any) => {
    // @ts-ignore
    this.sendRequest("submitProcedureInfo", para, success, error);
  };

  getPrimaryProcedureOwnerDDL: ServiceFunction<string, { id: string; name: string }[]> = (
    para,
    success,
    error
  ) => {
    // @ts-ignore
    this.sendRequest("getPrimaryProcedureOwnerDDL", para, success, error);
  };

  checkSectionLock = (para: any, success: any, error: any) => {
    // @ts-ignore
    this.sendRequest("checkSectionLock", para, success, error);
  };

  setSectionLock = (para: any, success: any, error: any) => {
    this.sendRequest("setSectionLock", para, success, error, {}, false, true);
  };

  releaseLockOnUnload = (para: { procedureId: any; procedureSectionType: any }) => {
    this.sendBeaconRequest("releaseSectionLockOnUnload", para);
  };

  getProcedureFileSection = (para: any, success: any, error: any) => {
    // @ts-ignore
    this.sendRequest("getProcedureFileSection", para, success, error);
  };

  getSupportingFileSection = (para: any, success: any, error: any) => {
    // @ts-ignore
    this.sendRequest("getSupportingFileSection", para, success, error);
  };

  checkSupportingFileEdit = (para: any, success: any, error: any) => {
    // @ts-ignore
    this.sendRequest("checkSupportingFileEdit", para, success, error);
  };

  getProcedureInfoSection = (para: any, success: any, error: any) => {
    // @ts-ignore
    this.sendRequest("getProcedureInfoSection", para, success, error);
  };

  getProcedureProcessStatus = (para: any, success: any, error: any) => {
    // @ts-ignore
    this.sendRequest("getProcedureProcessStatus", para, success, error);
  };

  getSignOffStepItem = (para: any, success: any, error: any) => {
    // @ts-ignore
    SignOffStepService.getStepData(para, success, error);
  };

  signOffTriggerAction = (para: any, success: any, error: any) => {
    // @ts-ignore
    this.sendRequest("signOffTriggerAction", para, success, error);
  };

  checkPPOEdit = (para: any, success: any, error: any) => {
    // @ts-ignore
    this.sendRequest("checkPPOEdit", para, success, error);
  };

  checkPOEdit = (para: any, success: any, error: any) => {
    // @ts-ignore
    this.sendRequest("checkPOEdit", para, success, error);
  };

  checkEditSection = (para: any, success: any, error: any) => {
    // @ts-ignore
    this.sendRequest("checkEditSection", para, success, error);
  };

  supportingFileUpdateCheck = (para: any, success: any, error: any) => {
    // @ts-ignore
    this.sendRequest("supportingFileUpdateCheck", para, success, error);
  };

  supportingFileSubmitCheck = (para: any, success: any, error: any) => {
    // @ts-ignore
    this.sendRequest("supportingFileSubmitCheck", para, success, error);
  };

  getRevisionCategory = (para: any, success: any, error: any) => {
    // @ts-ignore
    this.sendRequest("getRevisionCategory", para, success, error);
  };

  getClientMembers = (para: any, success: any, error: any) => {
    // @ts-ignore
    this.sendRequest("getClientMembers", para, success, error);
  };

  getProcedureFolderStepItem = (
    para: any,
    success: any,
    error: any,
    interfaceList: any,
    mergePayloadMap: any
  ) => {
    ProcedureFileStepService.getStepData(para, success, error, interfaceList, mergePayloadMap);
  };

  createProcedureTriggerApprovePageAction = (para: any, success: any, error: any) => {
    // @ts-ignore
    this.sendRequest("createProcedureTriggerApprovePageAction", para, success, error);
  };

  createProcedureTriggerRevisePageAction = (para: any, success: any, error: any) => {
    // @ts-ignore
    this.sendRequest("createProcedureTriggerRevisePageAction", para, success, error);
  };

  updateProcedureTriggerApprovePageAction = (para: any, success: any, error: any) => {
    // @ts-ignore
    this.sendRequest("updateProcedureTriggerApprovePageAction", para, success, error);
  };

  updateProcedureTriggerRevisePageAction = (para: any, success: any, error: any) => {
    // @ts-ignore
    this.sendRequest("updateProcedureTriggerRevisePageAction", para, success, error);
  };

  getHistoricalFiles = (para: any, success: any, error: any) => {
    // @ts-ignore
    this.sendRequest("getHistoricalFiles", para, success, error);
  };

  checkCreateProcedureFileSubmit = (para: any, success: any, error: any) => {
    // @ts-ignore
    this.sendRequest("checkCreateProcedureFileSubmit", para, success, error);
  };

  checkUpdateProcedureFileSubmit = (para: any, success: any, error: any) => {
    // @ts-ignore
    this.sendRequest("checkUpdateProcedureFileSubmit", para, success, error);
  };

  registerFileShare: ServiceFunction<RegisterFileSharePayload, RegisterFileShareResponse> = (
    para: RegisterFileSharePayload,
    success,
    error,
    returnPara
  ) => {
    // @ts-ignore
    return this.sendExternalRequest("registerFileShare", para, success, error, returnPara);
  };

  getShowEditPermission = (para: any, success: any, error: any) => {
    // @ts-ignore
    this.sendRequest("getShowEditPermission", para, success, error);
  };

  getFlowStepData: ServiceFunction<IFlowDataPayload, IFlowDataResponse> = (
    para,
    success,
    error
  ) => {
    // @ts-ignore
    this.sendRequest("getFlowStepData", para, success, error);
  };

  getProcedureInfoByProcedureTaskId = (para: any, success: any, error: any) => {
    // @ts-ignore
    this.sendRequest("getProcedureInfoByProcedureTaskId", para, success, error);
  };

  // @ts-ignore
  getProcedureFolderStepItemSingle = (para: IFlowDataPayload) =>
    this.sendSyncRequest(
      "getProcedureFileStepItemCompleted",
      para
    ) as Promise<IProcedureFileStepItem>;
}

const procedureDetailService = new ProcedureDetailService();

export default procedureDetailService;
